<template>
    <b-modal id="modal_form"
             ref="modal_form"
             :title="modal_titulo"
             :ok-title="modal_botao"
             close-title="Fechar"
             cancel-title="Cancelar"
             size="lg"
             :ok-disabled=form.errors.any()
             v-model="showModal"
             @ok="handleOk">

        <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
            <b-row no-gutters>
                <b-col>
                    <label tag="div">Descrição</label>
                    <b-form-input type="text"
                                 placeholder="Descrição"
                                 v-model="form.descr"
                                 name="descr">
                    </b-form-input>
                    <b-form-feedback v-text="form.errors.get('descr')" v-if="form.errors.has('descr')"></b-form-feedback>
                </b-col>
                <b-col>
                    <label tag="div">Layout</label>
                    <multiselect v-model="layoutSelected"
                    :options="optionsLayout"
                    track-by="value"
                    label="label"
                    :hide-selected="true"
                    placeholder="Selecione"
                    tag-placeholder="Selecionar"
                    select-label="Selecionar"
                    selected-label="Selecionado"
                    deselect-label="Remover"
                    ></multiselect>
                    <b-form-feedback v-text="form.errors.get('tp_entidade')" v-if="form.errors.has('lay_id')"></b-form-feedback>
                </b-col>
                <b-col>
                    <label tag="div">Entidade</label>
                    <multiselect v-model="tpEntidadeSelected"
                    :options="optionsTpEntidade"
                    track-by="value"
                    label="label"
                    :hide-selected="true"
                    placeholder="Selecione"
                    tag-placeholder="Selecionar"
                    select-label="Selecionar"
                    selected-label="Selecionado"
                    deselect-label="Remover"
                    ></multiselect>
                    <b-form-feedback v-text="form.errors.get('tp_entidade')" v-if="form.errors.has('tp_entidade')"></b-form-feedback>
                </b-col>
                <b-col md="1" sm="1">
                    <label>Chamada</label>
                        <b-form-group>
                          <b-form-radio-group
                            v-model="form.tp_chamada"
                            :options="optionsTpChamada"
                            name="tp_chamada"
                            plain
                            stacked
                            value-field="value"
                          ></b-form-radio-group>
                        </b-form-group>
                    <b-form-feedback v-text="form.errors.get('tp_chamada')" v-if="form.errors.has('tp_chamada')"></b-form-feedback>
                </b-col>
                <b-col md="1" sm="1">
                    <label>Fluxo</label>
                        <b-form-group>
                          <b-form-radio-group
                            v-model="form.tp_fluxo"
                            :options="optionsTpFluxo"
                            name="tp_fluxo"
                            plain
                            stacked
                            value-field="value"
                          ></b-form-radio-group>
                        </b-form-group>
                    <b-form-feedback v-text="form.errors.get('tp_fluxo')" v-if="form.errors.has('tp_fluxo')"></b-form-feedback>
                </b-col>
            </b-row>
            <b-row no-gutters>
                <b-col md="1" sm="1">
                    <label>Status FTP</label>
                        <b-form-group>
                          <b-form-radio-group
                            v-model="form.status_ftp"
                            :options="optionsStatusFtp"
                            name="status_ftp"
                            plain
                            stacked
                            value-field="value"
                          ></b-form-radio-group>
                        </b-form-group>
                    <b-form-feedback v-text="form.errors.get('status_ftp')" v-if="form.errors.has('status_ftp')"></b-form-feedback>
                </b-col>
                <b-col md="1" sm="1">
                    <label>Status Email</label>
                        <b-form-group>
                          <b-form-radio-group
                            v-model="form.status_email"
                            :options="optionsStatusEmail"
                            name="status_email"
                            plain
                            stacked
                            value-field="value"
                          ></b-form-radio-group>
                        </b-form-group>
                    <b-form-feedback v-text="form.errors.get('status_email')" v-if="form.errors.has('status_email')"></b-form-feedback>
                </b-col>
                <b-col md="1" sm="1">
                    <label>Status API</label>
                        <b-form-group>
                          <b-form-radio-group
                            v-model="form.status_api"
                            :options="optionsStatusApi"
                            name="status_api"
                            plain
                            stacked
                            value-field="value"
                          ></b-form-radio-group>
                        </b-form-group>
                    <b-form-feedback v-text="form.errors.get('status_api')" v-if="form.errors.has('status_api')"></b-form-feedback>
                </b-col>
                <b-col md="1" sm="1">
                    <label>Status XML</label>
                        <b-form-group>
                          <b-form-radio-group
                            v-model="form.status_xml"
                            :options="optionsStatusXml"
                            name="status_xml"
                            plain
                            stacked
                            value-field="value"
                          ></b-form-radio-group>
                        </b-form-group>
                    <b-form-feedback v-text="form.errors.get('status_xml')" v-if="form.errors.has('status_xml')"></b-form-feedback>
                </b-col>
                <b-col md="1" sm="1">
                    <label>Status Json</label>
                        <b-form-group>
                          <b-form-radio-group
                            v-model="form.status_json"
                            :options="optionsStatusJson"
                            name="status_json"
                            plain
                            stacked
                            value-field="value"
                          ></b-form-radio-group>
                        </b-form-group>
                    <b-form-feedback v-text="form.errors.get('status_json')" v-if="form.errors.has('status_json')"></b-form-feedback>
                </b-col>
                <b-col md="1" sm="1">
                    <label>Status Txt</label>
                        <b-form-group>
                          <b-form-radio-group
                            v-model="form.status_txt"
                            :options="optionsStatusTxt"
                            name="status_txt"
                            plain
                            stacked
                            value-field="value"
                          ></b-form-radio-group>
                        </b-form-group>
                    <b-form-feedback v-text="form.errors.get('status_txt')" v-if="form.errors.has('status_txt')"></b-form-feedback>
                </b-col>
                <b-col md="1" sm="1">
                    <label>Status</label>
                        <b-form-group>
                          <b-form-radio-group
                            v-model="form.status"
                            :options="optionsStatus"
                            name="status"
                            plain
                            stacked
                            value-field="value"
                          ></b-form-radio-group>
                        </b-form-group>
                    <b-form-feedback v-text="form.errors.get('status')" v-if="form.errors.has('status')"></b-form-feedback>
                </b-col>
            </b-row>

        </form>
        <div slot="modal-footer" class="w-100">
            <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
            <div class="float-right">
                 <b-btn @click="showModal=false" variant="secondary">
                   Fechar
                 </b-btn>
                 <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                   Enviar
                 </b-btn>
            </div>
        </div>
    </b-modal>
</template>
<script>

export default {
components: {
},
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
data () {
    return {
      dataExport: [],
      modal_titulo: '',
      modal_botao: '',
      modal_acao: '',
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      optionsTpChamada: [],
      optionsTpEntidade: [],
      optionsTpFluxo: [],
      optionsStatusEmail: [],
      optionsStatusApi: [],
      optionsStatusXml: [],
      optionsStatusJson: [],
      optionsStatusTxt: [],
      optionsStatusFtp: [],
      optionsLayout: [],
      optionsStatus: [],
      layoutSelected: [],
      tpEntidadeSelected: [],
      form: new Form({ lay_id: '',
                       descr: '',
                       tp_chamada: '',
                       tp_entidade: '',
                       tp_fluxo: '',
                       status_email: '',
                       status_api: '',
                       status_xml: '',
                       status_json: '',
                       status_txt: '',
                       status_ftp: '',
                       slug: '',
                       intgat_id: '',
                       status: ''
                   }),
     helpForm: new Form({statusRecord: [], params: []}),
    fields: [],
  css: {
      loadingClass: 'loading',
      ascendingIcon: 'glyphicon glyphicon-chevron-up',
      descendingIcon: 'glyphicon glyphicon-chevron-down',
      handleIcon: 'glyphicon glyphicon-menu-hamburger',
  },
  moreParams: {}
   }
},
watch: {
    tpEntidadeSelected(obj) {
        this.form.tp_entidade = obj.value;
    },
    layoutSelected(obj) {
        this.form.lay_id = obj.value;
    }
},
mounted() {
    this.getLivGeral();
},
methods: {
    handleOk(e)
    {
        e.preventDefault();
        if(this.modal_acao=="i")
        {
           this.onStore();
        }
        else
        {
            this.onUpdate(this.form.intgat_id);
        }
    },
    onCreate ()
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.form.reset();
      this.$refs.modal_form.show();
    },
    onEdit (data, index, id)
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form.reset();
      this.form.status = data.status.valor;
      this.form.descr = data.descr;
      this.form.tp_fluxo = data.tp_fluxo.valor;
      this.form.tp_chamada = data.tp_chamada.valor;
      this.form.status_ftp = data.status_ftp.valor;
      this.form.status_email = data.status_email.valor;
      this.form.status_api = data.status_api.valor;
      this.form.status_xml = data.status_xml.valor;
      this.form.status_json = data.status_json.valor;
      this.form.status_txt = data.status_txt.valor;
      this.layoutSelected = { label: data.layout.descr, value: data.layout.lay_id };
      this.tpEntidadeSelected = { label: data.tp_entidade.descr, value: data.tp_entidade.valor };
      this.form.intgat_id = data.intgat_id;
      this.$refs.modal_form.show();
    },
    onStore()
    {
        this.loading = true;
        this.isDisabled = true;
        //this.form.status = this.form.status.value;
        this.form.put('/api/'+this.rota+'/store').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });
    },
    onUpdate(id)
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.patch('/api/'+this.rota+'/update/'+id).then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });
    },
    onActivateDesactivate(helpForm)
    {
        helpForm.patch('/api/'+this.rota+'/status').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });

    },
    getLivGeral()
    {
        this.helpForm.get('/api/interfacegateway/jsonlistgeral').then(response =>
        {
            new ReturnApi(response, this, true, false, false);
            response.tp_chamada.forEach((obj)=>
            {
                this.optionsTpChamada.push({ text: obj.descr, value: obj.valor })
            })
            response.tp_entidade.forEach((obj)=>
            {
                this.optionsTpEntidade.push({ label: obj.descr, value: obj.valor })
            })
            response.tp_fluxo.forEach((obj)=>
            {
                this.optionsTpFluxo.push({ text: obj.descr, value: obj.valor })
            })
            response.status_email.forEach((obj)=>
            {
                this.optionsStatusEmail.push({ text: obj.descr, value: obj.valor })
            })
            response.status_api.forEach((obj)=>
            {
                this.optionsStatusApi.push({ text: obj.descr, value: obj.valor })
            })
            response.status_xml.forEach((obj)=>
            {
                this.optionsStatusXml.push({ text: obj.descr, value: obj.valor })
            })
            response.status_json.forEach((obj)=>
            {
                this.optionsStatusJson.push({ text: obj.descr, value: obj.valor })
            })
            response.status_txt.forEach((obj)=>
            {
                this.optionsStatusTxt.push({ text: obj.descr, value: obj.valor })
            })
            response.status_ftp.forEach((obj)=>
            {
                this.optionsStatusFtp.push({ text: obj.descr, value: obj.valor })
            })
            response.status.forEach((obj)=>
            {
                this.optionsStatus.push({ text: obj.descr, value: obj.valor })
            })
            response.layout.forEach((obj)=>
            {
                this.optionsLayout.push({ label: obj.descr, value: obj.lay_id })
            })

        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });
    },
    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
        return this.getPermissionFw(checkPermission);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    }
}
}
</script>
